<template>
  <v-layout v-bind="$attrs">
    <transition name="pop-in">
      <slot
        v-if="isLoaded && !exiting && !isThereRequiredProps"
        v-bind="{...dialogData, isLoaded}"
      />
    </transition>
    <VcLoader
      class="loader"
      v-if="!isLoaded || isThereRequiredProps"/>
  </v-layout>
</template>

<script>
  export default {
    data() {
      return {
        dialogData: {},
        isLoaded: false,
        exiting: false,
        isThereRequiredProps: false
      }
    },
    created() {
      this.$frontageApi.listen('frontage-acknowledge-dialog-loaded', this.frontageAcknowledge);
      this.$frontageApi.listen('frontage-update-dialog-props', this.updateProps);
      this.$frontageApi.listen('frontage-close-dialog', this.handleClose);
      this.$frontageApi.send('vue-dialog-loaded')
    },
    methods: {
      handleClose(data = null) {
        this.handleFrontageClose(() => this.$frontageApi.send('vue-dialog-close', data))
      },
      handleSubmit(data) {
        this.handleFrontageClose(() => this.$frontageApi.send('vue-dialog-submit', data))
      },
      handleFrontageClose(cb) {
        this.exiting = true
        setTimeout(cb,600) //to enable popout transition to take effect
      },
      frontageAcknowledge(data) {
        this.dialogData = data.props
        this.sendDialogData()
        this.isLoaded = true
        this.$frontageApi.remove('frontage-acknowledge-dialog-loaded')

        this.isThereRequiredProps = data.isThereRequiredProps
        if (data.isThereRequiredProps) {
          this.$frontageApi.listen('frontage-required-dialog-props', this.handleRequiredProps)
        }
      },
      handleRequiredProps(data) {
        this.isThereRequiredProps = false
        this.updateProps(data)
      },
      updateProps(data) {
        this.dialogData = { ...this.dialogData, ...data}
        this.sendDialogData()
      },
      sendDialogData() {
        this.$emit('dialogData', this.dialogData)
      }
    },
    beforeDestroy() {
      this.handleClose()
    },
    destroyed() {
      this.$frontageApi.remove('frontage-acknowledge-dialog-loaded', this.frontageAcknowledge);
      this.$frontageApi.remove('frontage-update-dialog-props', this.updateProps);
      this.$frontageApi.remove('frontage-required-dialog-props', this.handleRequiredProps);
    }
  }
</script>

<style lang="scss" scoped>
  .loader {
    margin: auto;
  }
  .pop-in-enter-active, .pop-in-leave-active  {
    transition: transform 0.3s;
  }
  .pop-in-enter, .pop-in-leave-to{
    transform: scale(0);
  }
</style>
